// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wm-form-field--floating-dropdown {
  position: relative;
  z-index: 50;
}

.wm-select-nearby-layer {
  position: relative;
  width: 100%;
  display: block;
}
.wm-select-nearby-layer-input {
  --padding-start: 0;
  --padding-end: 0;
  --background: transparent;
  width: 100%;
}
.wm-select-nearby-layer-list {
  position: absolute;
  z-index: 9999;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  width: 100%;
  background: var(--ion-background-color, #ffffff);
  border: 1px solid var(--ion-color-step-150, #d7d8da);
  border-radius: 6px;
  max-height: 240px;
  overflow-y: auto;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
  padding: 4px 0;
}
.wm-select-nearby-layer-option {
  display: block;
  width: 100%;
  min-height: 44px;
  padding: 10px 16px;
  margin: 0;
  border: none;
  background: transparent;
  text-align: left;
  cursor: pointer;
  font-family: inherit;
  font-size: var(--wm-font-mf, 14px);
  color: var(--ion-text-color, #000);
  line-height: 1.3;
}
.wm-select-nearby-layer-option:hover {
  background: var(--ion-color-step-50, #f4f5f8);
}
.wm-select-nearby-layer-option.is-selected {
  background: var(--ion-color-step-100, #e8edf4);
  font-weight: var(--wm-font-weight-bold, 600);
}
.wm-select-nearby-layer-empty {
  padding: 12px 16px;
  color: var(--ion-color-medium, #92949c);
  text-align: center;
  font-size: var(--wm-font-mf, 14px);
}`, "",{"version":3,"sources":["webpack://./src/app/shared/wm-core/projects/wm-core/src/form/select-nearby-layer/select-nearby-layer.component.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,WAAA;AADF;;AAIA;EACE,kBAAA;EACA,WAAA;EACA,cAAA;AADF;AAGE;EACE,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,WAAA;AADJ;AAIE;EACE,kBAAA;EACA,aAAA;EACA,qBAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,gDAAA;EACA,oDAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,0CAAA;EACA,cAAA;AAFJ;AAKE;EACE,cAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,kCAAA;EACA,kCAAA;EACA,gBAAA;AAHJ;AAKI;EACE,6CAAA;AAHN;AAMI;EACE,8CAAA;EACA,4CAAA;AAJN;AAQE;EACE,kBAAA;EACA,uCAAA;EACA,kBAAA;EACA,kCAAA;AANJ","sourcesContent":["// Solleva lo stacking context dell'intero ion-item che contiene questo componente\n// per evitare che gli ion-item successivi vengano dipinti sopra il dropdown.\n.wm-form-field--floating-dropdown {\n  position: relative;\n  z-index: 50;\n}\n\n.wm-select-nearby-layer {\n  position: relative;\n  width: 100%;\n  display: block;\n\n  &-input {\n    --padding-start: 0;\n    --padding-end: 0;\n    --background: transparent;\n    width: 100%;\n  }\n\n  &-list {\n    position: absolute;\n    z-index: 9999;\n    top: calc(100% + 4px);\n    left: 0;\n    right: 0;\n    width: 100%;\n    background: var(--ion-background-color, #ffffff);\n    border: 1px solid var(--ion-color-step-150, #d7d8da);\n    border-radius: 6px;\n    max-height: 240px;\n    overflow-y: auto;\n    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);\n    padding: 4px 0;\n  }\n\n  &-option {\n    display: block;\n    width: 100%;\n    min-height: 44px;\n    padding: 10px 16px;\n    margin: 0;\n    border: none;\n    background: transparent;\n    text-align: left;\n    cursor: pointer;\n    font-family: inherit;\n    font-size: var(--wm-font-mf, 14px);\n    color: var(--ion-text-color, #000);\n    line-height: 1.3;\n\n    &:hover {\n      background: var(--ion-color-step-50, #f4f5f8);\n    }\n\n    &.is-selected {\n      background: var(--ion-color-step-100, #e8edf4);\n      font-weight: var(--wm-font-weight-bold, 600);\n    }\n  }\n\n  &-empty {\n    padding: 12px 16px;\n    color: var(--ion-color-medium, #92949c);\n    text-align: center;\n    font-size: var(--wm-font-mf, 14px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
